import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/thefirm-logo-new.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const closeMenu = () => setIsOpen(false);

  const handleNavigation = (path) => {
    closeMenu();
    if (path === '/') {
      navigate(path);
      window.scrollTo(0, 0);
    } else if (path.startsWith('#')) {
      if (window.location.pathname !== '/') {
        navigate('/', { state: { scrollTo: path } });
      } else {
        const element = document.querySelector(path);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand" onClick={() => handleNavigation('/')}>
        <img src={logo} alt="The Firm Logo" className="navbar-logo" />
        <span className="brand-text">THE FIRM</span>
      </div>
      
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
        <div className="nav-group">
          <a href="/" onClick={(e) => { e.preventDefault(); handleNavigation('/'); }}>Home</a>
          <Link to="/academy" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Academy</Link>
          <Link to="/documentation" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Docs</Link>
          <Link to="/partnerships" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Partners</Link>
        </div>

        <div className="nav-group">
          <a href="#about" onClick={(e) => { e.preventDefault(); handleNavigation('#about'); }}>About</a>
          <a href="#token" onClick={(e) => { e.preventDefault(); handleNavigation('#token'); }}>Token</a>
          <Link to="/nft" className="nav-link">NFT</Link>
        </div>

        <a 
          href="https://t.me/TheFirmAIProtocols_bot" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="nav-cta"
          onClick={closeMenu}
        >
          Launch App
        </a>
      </div>
    </nav>
  );
};

export default Navbar; 